export default __webpack_public_path__ + "static/silkserif-light-8de30126ad73b026a4453b643999db86.woff2";